
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.335 10a.998.998 0 01-.258.66 1.015 1.015 0 01-.66.274h-6.49v6.475a.912.912 0 01-.275.66.903.903 0 01-.644.274.935.935 0 01-.934-.934v-6.475H2.583a.934.934 0 010-1.868h6.49V2.59a.935.935 0 01.935-.934.903.903 0 01.644.274.912.912 0 01.274.66v6.475h6.491a1.015 1.015 0 01.66.274.998.998 0 01.258.66z"}})])
          )
        }
      }
    